import { createAction, props } from '@ngrx/store';
import {Client} from '../../models/Client';
import {Contact} from '../../models/Contact';
import {Channel} from '../../enums/channel';
import {Form} from "../interfaces/form";
import {FormCreateDto} from "../interfaces/dto/form-create.dto";
import {FormUpdateDto} from "../interfaces/dto/form-update.dto";
import {Patient} from "../../models/Patient";
import {FormSubmissionCreateDto} from "../interfaces/dto/form-submission-create.dto";
import {FormSubmission} from "../interfaces/form-submission";
import { FormDraftPublishedStatus } from '../../enums/form-draft-published-status';
import { FormTakePayment } from '../../enums/form-take-payment';
import { FormFilterArchiveStatus } from '../../enums/form-filter-archive-status';
import { ClientInsights } from '../../models/ClientInsights';

export const OpenFormRequest = createAction(
  '[Forms] Open New Form Request',
  props<{client?: Client, contact?: Contact, channel?: Channel}>()
);

export const CloseFormRequest = createAction(
  '[Forms] Close New Form Request'
);

export const GetSendFormPatientsSuccess = createAction(
  '[Form] Form send get Patients Success',
  props<{patients: Patient[], replace: boolean}>()
);

export const GetMoreSendFormPatients = createAction(
  '[Form] Get More Form Send Patients',
  props<{page: number}>()
);

export const SetFormRequestClient = createAction(
  '[Forms] Set Form Request Client',
  props<{client?: Client}>()
);

export const SetFormRequestContact = createAction(
  '[Forms] Set Form Request Contact',
  props<{contact?: Contact}>()
);

export const SetFormRequestChannel = createAction(
  '[Forms] Set Form Request Channel',
  props<{channel?: Channel}>()
);

export const GetAllForms = createAction(
  '[Forms] Get All Forms',
  props<{search?: string}>()
);

export const GetAllFormsSuccess = createAction(
  '[Forms] Get All Forms Success',
  props<{forms: Form[]}>()
);

export const GetAllFormsFailed = createAction(
  '[Forms] Get All Forms Failed'
);
export const SearchForms = createAction(
  '[Forms] Search Form',
  props<{search?: string, isDraft?: boolean}>()
);

export const SearchFormsSuccess = createAction(
  '[Forms] Search Form Success',
  props<{forms: Form[]}>()
);

export const SearchFormsFailed = createAction(
  '[Forms] Search Form Failed'
);

export const GetForm = createAction(
  '[Forms] Get Form',
  props<{formId: number}>()
);

export const DuplicateForm = createAction(
  '[Forms] Duplicate Form',
  props<{formId: number}>()
);

export const GetFormSuccess = createAction(
  '[Forms] Get Form Success',
  props<{form: Form}>()
);

export const DuplicateFormSuccess = createAction(
  '[Forms] Duplicate Form Success',
  props<{form: Form}>()
);

export const GetFormFailed = createAction(
  '[Forms] Get Form Failed'
);

export const DuplicateFormFailed = createAction(
  '[Forms] Duplicate Form Failed'
);

export const GetFormToSend = createAction(
  '[Forms] Get Form To Send',
  props<{formId: number}>()
);

export const GetFormToSendSuccess = createAction(
  '[Forms] Get Form To Send Success',
  props<{form: Form}>()
);

export const ClearCurrentForm = createAction(
  '[Forms] Clear Current Form'
);

export const CreateForm = createAction(
  '[Forms] Create Form',
  props<{dto: FormCreateDto}>()
);

export const CreateFormSuccess = createAction(
  '[Forms] Create Form Success',
  props<{form: Form, dto: FormCreateDto}>()
);

export const CreateFormFailed = createAction(
  '[Forms] Create Form Failed'
);

export const UpdateForm = createAction(
  '[Forms] Update Form',
  props<{dto: FormUpdateDto}>()
);

export const UpdateFormSuccess = createAction(
  '[Forms] Update Form Success',
  props<{form: Form, dto: FormUpdateDto}>()
);

export const UpdateFormFailed = createAction(
  '[Forms] Update Form Failed'
);

export const OpenFormPreview = createAction(
  '[Forms] Create Or Update And Open Form Preview',
  props<{dto: FormCreateDto | FormUpdateDto}>()
);

export const OpenFormPreviewSuccess = createAction(
  '[Forms] Open Form Preview Success',
  props<{form: Form}>()
);

export const OpenFormPreviewFailed = createAction(
  '[Forms] Open Form Preview Failed'
);

export const ClearFormPreviewResult = createAction(
  '[Forms] Clear Form Preview Result'
);

export const PublishForm = createAction(
  '[Forms] Publish Form',
  props<{dto: FormCreateDto | FormUpdateDto}>()
);

export const PublishFormSuccess = createAction(
  '[Forms] Publish Form Success',
  props<{form: Form}>()
);

export const PublishFormFailed = createAction(
  '[Forms] Publish Form Failed'
);

export const UnpublishForm = createAction(
  '[Forms] Unpublish Form',
  props<{dto: FormCreateDto | FormUpdateDto}>()
);

export const UnpublishFormSuccess = createAction(
  '[Forms] Unpublish Form Success',
  props<{form: Form}>()
);

export const UnpublishFormFailed = createAction(
  '[Forms] Unpublish Form Failed'
);

export const ArchiveForm = createAction(
  '[Forms] Archive Form',
  props<{formId: number, archived: boolean}>()
);

export const ArchiveFormSuccess = createAction(
  '[Forms] Archive Form Success',
  props<{form: Form}>()
);

export const ArchiveFormFailed = createAction(
  '[Forms] Archive Form Failed'
);

export const CreateFormSubmission = createAction(
  '[Forms] Create Form Submission',
  props<{dto: FormSubmissionCreateDto, client: Client | null, contact: Contact | null, channel: Channel}>()
);

export const CreateFormSubmissionSuccess = createAction(
  '[Forms] Create Form Submission Success',
  props<{formSubmission: FormSubmission, client: Client | null, contact: Contact | null, channel: Channel}>()
);

export const CreateFormSubmissionFailed = createAction(
  '[Forms] Create Form Submission Failed'
);

export const SendFormSubmission = createAction(
  '[Forms] Send Form Submission',
  props<{formSubmission: FormSubmission, client?: Client | null, contact?: Contact | null, channel: Channel}>()
);

export const SendFormSubmissionSuccess = createAction(
  '[Forms] Send Form Submission Success'
);

export const SendFormSubmissionFailed = createAction(
  '[Forms] Send Form Submission Failed'
);

export const GetFormSubmissions = createAction(
  '[Forms] Get Form Submissions',
  props<{page: number, perPage: number, searchString: string | null, status?: string, saveToPms?: string, date?: string | object , clientPmsId?: string | undefined}>()
);

export const GetFormSubmissionsSuccess = createAction(
  '[Forms] Get Form Submissions Success',
  props<{formSubmissions: FormSubmission[], totalCount: number}>()
);

export const GetFormSubmissionsFailed = createAction(
  '[Forms] Get Form Submissions Failed'
);

export const GetClientFormSubmissions = createAction(
  '[Forms] Get Client Form Submissions',
  props<{client: Client | ClientInsights}>()
);

export const GetClientFormSubmissionsSuccess = createAction(
  '[Client] Get Client Form Submissions Success',
  props<{formSubmissions: FormSubmission[]}>()
);

export const GetFormSubmission = createAction(
  '[Forms] Get Form Submission',
  props<{uuid: string}>()
);

export const GetFormSubmissionSuccess = createAction(
  '[Forms] Get Form Submission Success',
  props<{formSubmission: FormSubmission}>()
);

export const GetFormSubmissionFailed = createAction(
  '[Forms] Get Form Submission Failed'
);

export const UpdateFormFilterDraftStatus = createAction(
  '[Form] Update Draft Status Filter',
  props<{option: FormDraftPublishedStatus}>()
);

export const UpdateFormFilterArchiveStatus = createAction(
  '[Form] Update Archive Status Filter',
  props<{option: FormFilterArchiveStatus}>()
);

export const UpdateFormFilterTakePayment = createAction(
  '[Form] Update Take Payment Filter',
  props<{option: FormTakePayment}>()
);

export const UpdateFormSubmissionSaveToPmsFilter = createAction(
  '[Form] Update Form Submission Save To PMS Filter',
  props<{option: string}>()
);

export const UpdateFormSubmissionStatusFilter = createAction(
  '[Form] Update Form Submission Status Filter',
  props<{option: string}>()
);

export const UpdateFormSubmissionDateFilter = createAction(
  '[Form] Update Form Submission Date Filter',
  props<{date: {start: string, end: string} | null | string }>()
);

export const SetTemplateSearchTerm = createAction(
  '[Forms] Set Template Search Term',
  props<{option: string}>()
);

export const ClearTemplateFilters = createAction(
  '[Forms] Clear Filters'
);
 export const ExportFormsSubmission = createAction(
  '[Forms] Export Forms Submission',
  props<{ formSubmissionUuids: string[], downloadPdfs: boolean }>()
);

export const ExportFormsSubmissionComplete = createAction(
  '[Forms] Export FormsSubmissions Complete',
);

export const RetryFormsSubmissionSyncToPms = createAction(
  '[Forms] Retry FormsSubmissions Sync To PMS',
  props<{ formSubmissionUuid: string }>()
);


export const RetryFormsSubmissionSyncToPmsSuccess = createAction(
  '[Forms] Retry FormsSubmissions Sync To PMS Success',
  props<{ formSubmission: FormSubmission }>()
);


export const RetryFormsSubmissionSyncToPmsFailed = createAction(
  '[Forms] Retry FormsSubmissions Sync To PMS Success',
  props<{ formSubmissionUuid: string }>()
);

export const SelectFormSubmissions = createAction(
  '[Forms] Select Form Submissions',
  props<{ formSubmission: FormSubmission, formSubmissionUuid: string, selected: boolean }>()
);